import React from "react";
import Home from "./pages/Home";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LeaveMessage from "./pages/LeaveMessage";
import CheckStatus from "./pages/CheckStatus";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/status",
    element: <CheckStatus />,
  },
  {
    path: "/message",
    element: <LeaveMessage />,
  },
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
